import { useContext } from 'react';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import { useApp, useAppDispatchers } from '../../state/app';
import { useUser, useUserDispatchers } from '../../state/user';
import { useToggles } from '../../state/toggles';
import ResetPassword from './index';

const ResetPasswordContainer = props => {
  const { analytics } = useContext(AnalyticsContext);
  const {
    loading,
    error,
    message,
    answers,
    validateResetPasswordTokenComplete,
    redirectOnError
  } = useApp();
  const {
    resetPassword,
    ltaResetPassword,
    validateResetPasswordToken,
    createError
  } = useAppDispatchers();
  const { deviceToken } = useUser();
  const { setNextRegStep } = useUserDispatchers();
  const { ltaResetPasswordExperience } = useToggles();

  const childProps = {
    ...props,
    analytics,
    answers,
    deviceToken,
    error,
    loading,
    message,
    validateResetPasswordTokenComplete,
    ltaResetPasswordExperience,
    redirectOnError,
    createError,
    resetPassword,
    ltaResetPassword,
    validateResetPasswordToken,
    setNextRegStep
  };
  return <ResetPassword {...childProps} />;
};

export default ResetPasswordContainer;
